var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCloud = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.006 4C9.438 4 6.965 5.622 5.738 8.425c-.058.135-.105.273-.157.41C3.516 9.538 2 11.7 2 14.288c0 3.156 2.238 5.714 5 5.714h10c2.762 0 5-2.558 5-5.714 0-2.586-1.513-4.744-3.574-5.45-.63-1.673-1.759-3.113-3.296-3.992A6.3 6.3 0 0 0 12.006 4m0 2.286c.777 0 1.527.204 2.229.604 1.052.601 1.888 1.613 2.354 2.85l.369.982.895.305c1.284.44 2.147 1.75 2.147 3.26 0 1.891-1.346 3.43-3 3.43H7c-1.654 0-3-1.539-3-3.43 0-1.512.865-2.823 2.152-3.26l.895-.305.37-.98.055-.148q.026-.073.055-.146c.853-1.95 2.569-3.162 4.479-3.162"
})));
export default SvgGemCloud;